'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { KEYS, MODIFIERS } from 'DesignData/enums/Keys';
import Keybinding from 'DesignData/models/Keybinding';
import EditorWrapper from 'DesignEditorsUI/components/shared/EditorWrapper';
import EditFormCard from 'DesignEditorsUI/components/globalWidgetEditor/EditFormCard';
import ToolbarContainer from 'DesignEditorsUI/components/globalWidgetEditor/ToolbarContainer';
import FormCardContainer from 'DesignEditorsUI/components/shared/formCard/FormCardContainer';

class GlobalWidgetEditor extends PureComponent {
  constructor(...args) {
    super(...args);
    this.keybindingConfig = {
      [MODIFIERS.COMMAND]: {
        [KEYS.Z]: new Keybinding({
          handler: this.props.undoGlobalWidgetEdit
        }),
        [KEYS.Y]: new Keybinding({
          handler: this.props.redoGlobalWidgetEdit
        })
      },
      [MODIFIERS.COMMAND_SHIFT]: {
        [KEYS.Z]: new Keybinding({
          handler: this.props.redoGlobalWidgetEdit
        })
      }
    };
  }

  render() {
    const {
      globalWidgetId,
      revisionId,
      isReadOnly
    } = this.props;
    return /*#__PURE__*/_jsxs(EditorWrapper, {
      className: "global-widget-editor",
      children: [/*#__PURE__*/_jsx(ToolbarContainer, {
        globalWidgetId: this.props.globalWidgetId
      }), /*#__PURE__*/_jsx(FormCardContainer, {
        children: /*#__PURE__*/_jsx(EditFormCard, {
          globalWidgetId: globalWidgetId,
          isReadOnly: isReadOnly,
          revisionId: revisionId,
          showPublishButton: false
        })
      })]
    });
  }

}

GlobalWidgetEditor.propTypes = {
  globalWidgetId: PropTypes.number.isRequired,
  revisionId: PropTypes.number,
  isReadOnly: PropTypes.bool.isRequired,
  undoGlobalWidgetEdit: PropTypes.func.isRequired,
  redoGlobalWidgetEdit: PropTypes.func.isRequired
};
export default GlobalWidgetEditor;